import { useAccount, useMsal } from '@azure/msal-react';
import { HeaderWithBar, POSButton, POSIcon, POSImage } from '@publicisgroupe/p-os-components';
import { Container } from 'semantic-ui-react';

import { t } from 'utils/resources';
import profile from '../WebFrameHeader/images/Icon-Profile-Fill.svg';

import './UserProfileSection.less';
import { useCallback } from 'react';
import { ROUTE_MODULE_CONFIG } from 'utils/routes';
import { useHistory } from 'react-router-dom';
import useModulePermissions from 'hooks/useModulePermissions';
import { CONFIG_MODULE_NAME } from 'utils/permissions';

interface Props {
  handleUserProfileSettingsSection: (val: boolean) => void;
  handleCookieBanner: () => void;
}

export const UserProfileSection = ({
  handleUserProfileSettingsSection,
  handleCookieBanner,
}: Props) => {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const getCurrentYear = new Date().getFullYear();
  const history = useHistory();
  const { isGranted } = useModulePermissions();

  const navigateToConfigModule = useCallback(() => {
    history.push(ROUTE_MODULE_CONFIG);
  }, [history]);

  return (
    <>
      <Container className="user-profile-section-container">
        <POSIcon
          icon="close"
          className="large close-icon"
          onClick={() =>
            handleUserProfileSettingsSection && handleUserProfileSettingsSection(false)
          }
        />
        <div className="user-profile-image">
          <img src={profile} alt="user-profile-image" width="60" />
        </div>
        <div className="user-info">
          <h4>{account?.name}</h4>
          <HeaderWithBar>{t('Dashboard.LoggedIn')}</HeaderWithBar>
          <div className="logout">
            <POSButton className="logout-action-btn" inverted onClick={() => instance.logout()}>
              {t('UserIcons.LogOut')}
            </POSButton>
          </div>
          <POSButton
            className="cookie-banner-action-btn"
            inverted
            onClick={() => handleCookieBanner()}
          >
            {t('UserProfile.CookieSettings')}
          </POSButton>
          {isGranted(CONFIG_MODULE_NAME, 'Config') && (
            <POSButton
              className="switch-to-config-action-btn"
              inverted
              onClick={navigateToConfigModule}
            >
              {t('UserProfileSwitchToConfigView')}
            </POSButton>
          )}
        </div>
      </Container>
      <div className="section-footer">
        <hr className="divider" />
        <div className="section-footer-content">
          <p className="powered-by">{t('Footer.PoweredbyText', true)}</p>
          <div className="footer-logo">
            <POSImage src="webframe/Publicis-Logo-White.png" />
          </div>
          <p className="rights-reserved">{`© ${getCurrentYear} ${t(
            'Footer.ReservedRightsNote'
          )}`}</p>
        </div>
      </div>
    </>
  );
};
